export const GALLERY = {
  init: function () {
    const galleryTitles = document.querySelectorAll('.p-top-gallery__contents-title-wrap')
    const galleryImages = document.querySelectorAll('.p-top-gallery__img-category')

    galleryTitles.forEach(galleryTitle => {
      galleryTitle.addEventListener('click', imageSwitch)
    })

    function imageSwitch(e) {
      // クリックされた要素のデータ属性を取得
      const targetCategory = e.currentTarget.dataset.category

      // 1. すべてのタイトルからis-activeを削除し、クリックされたタイトルにis-activeを追加
      galleryTitles.forEach(title => {
        title.classList.remove('is-active')
      })
      e.currentTarget.classList.add('is-active')

      // 2. すべての画像カテゴリーからis-showを削除し、ターゲットのカテゴリーにis-showを追加
      galleryImages.forEach(imageCategory => {
        if (imageCategory.dataset.category === targetCategory) {
          imageCategory.classList.add('is-show')
        } else {
          imageCategory.classList.remove('is-show')
        }
      })
    }
  },
}
